export default __webpack_public_path__ + "static/media/flag.d3f9e489.png";